import { Component, Input, OnInit } from "@angular/core";
import { FromToDetail, ReportRectangle } from "../../../../../_objects/report-element";
import { Notifier, OfflineReportPreviewService, MousePoint } from "../../../../../_services/offline-report-preview.service";

@Component({
  selector: "app-report-rectangle-container-offline",
  templateUrl: "./report-rectangle.component.html",
  styleUrls: ["./report-rectangle.component.scss"],
  standalone: false
})
export class ReportRectangleOfflineComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public rectangleKey: string;
  @Input() public elementLocation: string;

  public reportRectangle: ReportRectangle;
  private resizeMarkerSize: number;
  private resizing: boolean;
  private notifier: Notifier;

  readonly rectangleStyle = "position: absolute; box-sizing: border-box; word-break: normal; white-space: pre-wrap;";

  constructor(public designService: OfflineReportPreviewService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: "report-rectangle.component",
      ids: { pageId: this.pageKey, elementId: this.rectangleKey }
    };
    this.reportRectangle = this.designService.getRectangle(this.rectangleKey);
  }

  public onClick(event: MouseEvent) {}

  public onDragStart(event: DragEvent) {
    // console.log('ReportRectangle onDragStart');
    event.dataTransfer.setData("text", this.rectangleKey);
    event.dataTransfer.effectAllowed = "move";

    const fromDetail: FromToDetail = {
      location: this.reportRectangle.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
  }

  public onDragOver(event: DragEvent) {
    // console.log('ReportRectangle onDragOver');
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    event.stopPropagation();
  }

  public onDrop(event: DragEvent) {
    // console.log('ReportRectangle onDrop');
    event.preventDefault();
    const template = { ...this.designService.originTemplate };
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    const dragElemId = event.dataTransfer.getData("text");

    const toDetail: FromToDetail = {
      location: this.reportRectangle.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportRectangle.getLeftPx() + event.offsetX,
      onElementY: this.reportRectangle.getTopPx() + event.offsetY
    };

    event.dataTransfer.clearData("text");
    event.stopPropagation();
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + "px";
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case "left":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "center":
        return this.reportRectangle.getWidthPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "right":
        return this.reportRectangle.getWidthPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    switch (vertical) {
      case "top":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "middle":
        return this.reportRectangle.getHeightPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "bottom":
        return this.reportRectangle.getHeightPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }
}
